module.exports = __webpack_public_path__ + "img/search.5826d271.svg";